import React, { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import { AngleUpLightIcon } from '../../../../shared/icons/icons';

import {
  getEventUIType,
  trackAction
} from '../../../../shared/utils/analytics/analytics';

import {
  AbstractCmsComponent,
  Maybe
} from '../../../../shared/types/graphql-types';

import './treadwell-custom-driver-type.scss';

const DragAndDrop = lazy(
  () => import('../../../../library/drag-and-drop/drag-and-drop')
);

interface TreadwellCustomDriverTypeProps {
  className?: string;
  onSelectedPriorities: (
    selectedPriorities: Array<Maybe<AbstractCmsComponent>>
  ) => void;
  onToggleIsCustomDriverTypeShowing?: () => void;
  selectedPriorities: Array<string>;
}

function TreadwellCustomDriverType(props: TreadwellCustomDriverTypeProps) {
  const {
    className,
    onSelectedPriorities,
    onToggleIsCustomDriverTypeShowing,
    selectedPriorities
  } = props;
  const location = useLocation();
  const uiElementType = getEventUIType(location);

  return (
    <div className={className} styleName="container">
      <div styleName="select-driver-type-btn-container">
        <Button
          onClick={() => {
            trackAction(`shop_${uiElementType}_treadwell_back_to_driver_types`);
            if (onToggleIsCustomDriverTypeShowing) {
              onToggleIsCustomDriverTypeShowing();
            }
          }}
          styleName="select-driver-type-btn"
        >
          <AngleUpLightIcon
            aria-hidden="true"
            styleName="select-driver-type-btn-icon"
          />
          Select your driver type
        </Button>
      </div>

      <div styleName="messaging">
        <Typography styleName="heading" tag="strong" weight="black">
          What are your driving priorities?
        </Typography>
        <Typography tag="span">
          Drag and drop to reorder your priorities.
        </Typography>
      </div>

      <div styleName="priority-container">
        <Suspense fallback={<div />}>
          <DragAndDrop
            dragDirection="vertical"
            items={selectedPriorities}
            onChange={onSelectedPriorities}
            styleName="dnd-container"
          />
        </Suspense>
      </div>
    </div>
  );
}

export default TreadwellCustomDriverType;
